export const APOLLO_ERROR_MESSAGE = {
  authenticationFailed: 'Authentication failed.',
}
